import React from 'react';
import { Row, Col, Avatar } from 'antd';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, loading, title, topPerformers, comment }) => {
  const itemsInGroup = 3;
  const avatarGroups = Array.from(Array(Math.ceil(topPerformers.length / itemsInGroup)),
                                  (_,index) => topPerformers.slice(index * itemsInGroup, index * itemsInGroup + itemsInGroup));

  const commentText = comment || (topPerformers && topPerformers.length > 0 ? null : 'Group members haven\'t got any Event seeds.');
  const groupPosition = topPerformers && topPerformers.length && data || [];

  return (
    <InfoCardWidget primaryColor="#000099" secondaryColor="#595959" icon="icon-people" title={title} data={groupPosition}
                    loading={loading} comment={commentText} >
      {topPerformers && topPerformers.length > 0 &&
        <div className="chart-container">
          <div className="chart-title">Top Performers</div>
          {
            avatarGroups.map((avatarGroup, index) => {
              return (
                <Row key={index} style={{paddingTop: '30px'}}>
                  {
                    avatarGroup.map((member, index) => {
                      return (
                        <Col className="avatar-with-name" key={index} sm={8} xs={24}
                             style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                          <Avatar icon="user" src={member.photo.small} size="large"/>
                          <div className="name">{member.name}</div>
                        </Col>
                      )
                    })
                  }
                </Row>
              );
            })
          }
        </div>
      }
    </InfoCardWidget>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/groupPerformance.js